import { render } from "./NewFixedAsset.vue?vue&type=template&id=06f098e4"
import script from "./NewFixedAsset.vue?vue&type=script&lang=js"
export * from "./NewFixedAsset.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__